import React from 'react';
import Page from '../../components/Page';
import Footer from '../../components/Footer';
import { flexContainer, keyVisual } from './LastPageStyle';
import imgKey from '../../assets/media/keystatements.webp';

const DefaultLastPage = () => {
    return (
        <Page fixedPageHeight>
            <div className={flexContainer}>
                <img className={keyVisual} style={{ flex: 1 }} src={imgKey} alt="Schlüssel" />
                <Footer />
            </div>
        </Page>
    );
};

export default DefaultLastPage;
